import type { SlideMetadata } from "@/services/api.service";

export const isCalculatorEnabled = (
  metadata: SlideMetadata | Record<string, unknown> | null | undefined,
): boolean => metadata?.calculator?.enabled === true;

export const buildCalculatorMetadataPatch = (
  enabled: boolean,
): Pick<SlideMetadata, "calculator"> => ({
  calculator: { enabled },
});
